/**
 * File: PassageController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import imagePopup from '../views/popup/imagePopup.html'
import passagePopup from '../views/popup/passagePopup.html'
class PassageController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, $mdMedia, uploadService) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        Simditor.locale = 'en-US';
        var editor = undefined
        editor = new Simditor({
            textarea: $('#editor'),
                placeholder: '',
                params: {},
                upload: false,
                tabIndent: true,
                toolbar: [
                    'title',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'fontScale',
                    'color',
                    'ol' ,      
                    'ul'  ,          
                    'blockquote',
                    'code',         
                    'table',
                    'link',
                    // 'image',
                    'hr',           
                    'indent',
                    'outdent',
                    'alignment'
                ],
                toolbarFloat: true,
                toolbarFloatOffset: 0,
                toolbarHidden: false,
                pasteImage: false,
                cleanPaste: false,
                codeLanguages : [{ name: 'Erlang', value: 'erlang' },]
                //optional options
        });
        //On destroy function
        this.$onDestroy = () => {
        }
        
        /********** BASIC DETAILS *********/
        let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
        let userId = localStorageService.get("user_id")
        let USER_PATH = userId + "/question/"
        let schoolId = localStorageService.get("school_id")
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
        let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
        let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
        let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
        let SAVE_URL = CQuesConst.API_CREATE_PASSAGE
        $scope.questionImage = [];
        $scope.descImage = [];
        $scope.explanationImage = [];
        $scope.isLatex = false
        $scope.content_editor_id = userId;

        /******* LIMIT FOR QUSTION CREATION *******/
        $scope.option_limit = CQuesConst.OPTION_LIMIT;
        $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;

        //SET UI FOR EDIT QUESTIONS
        let editQuestion = $scope.$parent.$parent.editQuestion
        if (editQuestion) {
            $scope._id = editQuestion._id;
            $scope.passage_name = editQuestion.passage_title;
            $scope.passage_desc = editQuestion.passage_desc;
            editor.setValue(editQuestion.passage_desc)
            $scope.question_ids = [];
            if(editQuestion.question_ids){
                $scope.question_ids = editQuestion.question_ids
            }
            if(editQuestion.passage_image){
                if(Array.isArray(editQuestion.passage_image)){
                    $scope.descImage = editQuestion.passage_image
                }else{
                    $scope.descImage.push(editQuestion.passage_image)
                }
            }
        }  

        //PREVENT PASTE FUNCTIONALITY
        $scope.paste = function (e) {
            e.preventDefault();
            return false
        }

        //Image upload for Desc
        $scope.descImgUpload = function (file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            $scope.descImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }


        //DIALOG CONTROLLER FOR IMAGE
        var imageDialogCtrl = function ($scope, $mdDialog, imageDetails) {
            $scope.fileUrl = PREVIEW_URL
            $scope.isPassage = false;
            $scope.title = imageDetails.title;
            $scope.imageArray = imageDetails.images;
            $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false

            $scope.deleteImage = function (imageIndex) {
                $scope.imageArray.splice(imageIndex, 1)
            }
            $scope.cancelDialog = function () {
                $mdDialog.cancel();
                $scope.descImage = $scope.imageArray
                $scope.imageArray = []
            };
        }

        //Open dialog to view image
        $scope.openDialog = () => {
            let imageDetails;
            imageDetails = {
                title: "Passage - Question Image",
                images: $scope.descImage
            }
            
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                locals: {
            
                    imageDetails: imageDetails
                },
                template: imagePopup,
                controller: ['$scope', '$mdDialog', 'imageDetails', imageDialogCtrl],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        }

        //DIALOG CONTROLLER FOR PASSAGE
        var passageDialogCtrl = function ($scope, $mdDialog, passages) {
            $scope.passages = passages
            /*
             * Function to cancel dialog to select passage
             */
            $scope.cancelPassage = function () {
                $mdDialog.cancel();
            };


            /*
             * Function to select passage
             */
            $scope.selectPassage = function (passage_id) {
                _.each($scope.passages, function (eachPas) {
                    if (eachPas._id === passage_id) {
                        if (eachPas.isSelected)
                            $scope.selectedPassage = eachPas;
                        else
                            $scope.selectedPassage = null
                    } else {
                        eachPas.isSelected = false;
                    }
                })
                $scope.cancelPassage()
            }

            /*
             * Function to cancel select passage
             */
            $scope.cancelSelectedPasssage = function () {
                $scope.selectedPassage = null
            }

        }

        //TO SET PASSAGE LIST
        var passageCallback = (resultObj) => {
            let isPassagePresent = false;
            if (resultObj && resultObj.result && resultObj.result.data) {
                var result = resultObj.result.data.passage ? resultObj.result.data.passage : []
                if (result) {
                    if (result.length > 0) {
                        isPassagePresent = true;
                        _.each(result, function (eachPas) {
                            if ($scope.selectedPassage && $scope.selectedPassage._id === eachPas._id) {
                                eachPas["isSelected"] = true
                            } else {
                                eachPas["isSelected"] = false
                            }
                        })
                        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                        $mdDialog.show({
                            locals: {
                                passages: result
                            },
                            template: passagePopup,
                            controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: useFullScreen
                        })
                    }
                }
            }
            if (!isPassagePresent) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('No Passage')
                        .textContent('No passages added yet. Please add passage and link it')
                        .ariaLabel('Passage Dialog')
                        .ok('Ok')
                );
            }
        }


        /*
         * Function to open dialog to select passage
         */
        $scope.openPassage = () => {
            let authoring = {
                curriculum_id: $scope.$parent.curriculum_id,
                class_id: $scope.$parent.class_id,
                subject_id: $scope.$parent.subject_id,
                school_id: schoolId
            }
            $scope.fileUrl = PREVIEW_URL
            $scope.isArray = function (obj) {
                return Array.isArray(obj);
            }
            authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback)
        }

        //Adding Passage question from UI
        $scope.$on('addPassage', function () {
            $scope.errors = {}
            let details = localStorageService.get("questionDetails")
            let question = details.question
            let activityErrorCount = details.errorCount;
            let editor_value = editor.getValue()
            $scope.passage_desc = editor_value
                 //Validation 
                 $scope.errors = {};

                 if ($scope.passage_name == undefined || $scope.passage_name == "" || $scope.passage_name == null) {
                     $scope.activityErrorCount++;
                     $scope.errors['passage_name'] = "Passage title is requrired"
                 }
                 if (editor_value == undefined || editor_value == "" || editor_value == null) {
                     $scope.activityErrorCount++;
                     $scope.errors["passage_desc"] = "Passage is requrired"
                 }
                 $scope.passage_desc = editor_value
            if (activityErrorCount === 0) {
                $scope.$parent.isSaveClicked = true;
                let obj = {
                    "_id": $scope._id,
                    "question_theme_id": question.theme._id,
                    "question_theme_name": question.theme.name,
                    "passage_image": $scope.descImage,
                    "passage_desc": editor_value,
                    "strand": question.strand,
                    "tag": question.tag,
                    "wave": question.wave,
                    "qn_desc": '' +  $scope.passage_name,
                    "level": question.level,
                    "subject_id": question.subject_id,
                    "school_id": question.school_id,
                    "session_id": question.session_id,
                    "batch_id": question.batch_id,
                    "class_id": question.class_id,
                    "curriculum_id": question.curriculum_id,
                    "xlink": question.link_theme,
                    "cognitive_skills": question.cognitive_skill,
                    "isNotAddToQp": question.isNotAddToQp,
                    "is_traditional_activity": question.is_traditional_activity,
                    "qp_id": question.qp_id,
                    "activity_id": question.activity_id,
                    "user_id": userId,
                    "created_dt": $scope.created_dt,
                    "content_editor_id": $scope.content_editor_id,
                    "teaching_plan_id": question.teaching_plan_id
                }
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    let result = resObj.result
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        $rootScope.resetValues()
                            if(question.question_type =="passage" && question.is_traditional_activity)
                            {
                                toastr.success("Passage Saved successfully.");
                                $scope.passage_name=undefined;
                                $scope.passage_desc=undefined;
                                $scope.descImage=[]

                            }
                            else if(question.question_type =="passage" && (question.teaching_plan_id!== undefined || question.teaching_plan_id !== null || question.teaching_plan_id !== ""))
                            {
                                toastr.success("Passage Saved successfully. ");
                                $scope.passage_name=undefined;
                                $scope.passage_desc=undefined;
                                $scope.descImage=[]

                            } else {
                                toastr.success("Passage saved successfully.");
                                $rootScope.setSearchFieldSession()
                            }
                            // if(result.data.isExists){
                            //     toastr.success("Question already exists");
                            // }
                            // else{
                            //     toastr.success("Question Saved successfully");
                            // }
                        
                    } else {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        toastr.error("Network Error")
                    }
                    _.defer(() => { $scope.$apply() })
                })
            } else {
                $rootScope.setHideSaveButton(false)
                $rootScope.setLoader(false)
                toastr.error("Please fill all mandatory fields")
            }
        })


    }
}

export default PassageController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/passageController.js